import React from 'react';
import { Link } from 'react-router-dom';

const HealthSocialCare = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-blue-900 text-white p-8 rounded-lg mb-8">
          <h1 className="text-4xl font-bold mb-2">Health & Social Care</h1>
          <p className="text-xl">Bachelor of Science (BSc Hons)</p>
          <div className="flex flex-wrap gap-6 mt-4 text-blue-100">
            <span>Duration: 3-4 Years</span>
            <span>360 UK Credits</span>
            <span>Intake: January, May, September</span>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-8">
            {/* Overview */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-2xl font-bold mb-4">Program Overview</h2>
              <p className="text-gray-700 mb-4">
                Our BSc (Hons) in Health & Social Care provides students with a comprehensive understanding 
                of health and social care practices, policies, and theories. The program is designed to 
                prepare graduates for rewarding careers in various healthcare and social service settings.
              </p>
              <h3 className="text-xl font-semibold mb-3">Why Choose This Program?</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Accredited by professional bodies</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Work placement opportunities</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Taught by experienced professionals</span>
                </li>
              </ul>
            </div>

            {/* Program Structure */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-2xl font-bold mb-4">Program Structure</h2>
              <h3 className="text-xl font-semibold mb-3">Core Modules</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div className="bg-blue-50 p-3 rounded">Introduction to Health & Social Care</div>
                <div className="bg-blue-50 p-3 rounded">Human Growth and Development</div>
                <div className="bg-blue-50 p-3 rounded">Safeguarding in Health & Social Care</div>
                <div className="bg-blue-50 p-3 rounded">Health Promotion</div>
              </div>
              <h3 className="text-xl font-semibold mb-3">Optional Modules</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-3 rounded">Mental Health and Wellbeing</div>
                <div className="bg-gray-50 p-3 rounded">Social Care with Older People</div>
                <div className="bg-gray-50 p-3 rounded">Public Health</div>
                <div className="bg-gray-50 p-3 rounded">Dementia Care</div>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            {/* Entry Requirements */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-xl font-bold mb-4">Entry Requirements</h2>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>A-levels: BCC or equivalent</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>BTEC: DMM in a relevant subject</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Access to HE Diploma: 45 credits at Level 3</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>IELTS 6.0 (5.5 in each component)</span>
                </li>
              </ul>
              <Link 
                to="/admissions/apply-now" 
                className="mt-4 inline-block bg-blue-900 text-white px-6 py-2 rounded hover:bg-blue-800 w-full text-center"
              >
                Apply Now
              </Link>
            </div>

            {/* Career Paths */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h2 className="text-xl font-bold mb-4">Career Opportunities</h2>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Social Worker</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Healthcare Manager</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Community Support Worker</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-2">•</span>
                  <span>Mental Health Support Worker</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthSocialCare;
